module.exports = {"ok":"ตกลง","cancel":"ยกเลิก","back":"ย้อนกลับ","edit":"แก้ไข","submit":"ยืนยัน","confirm":"ยืนยัน","yes":"ใช่","no":"ไม่","done":"เสร็จสิ้น","AdvancedSearch":"ค้นหาอย่างละเอียด","Update":"แก้ไข","Print":"พืมพ์รูปนี้!","Enabled":"เปิดให้ใช้","Disable":"ปิดไม่ให้ใช้","View":"ดูข้อมูล","QRCode":"QR Code","Delete":"ลบ","Search":"ค้นหา","Clear":"ล้างค่า","UserO365":"นำเข้ารายชื่อจาก O365","Add":"เพิ่ม","Next":"ต่อไป","Unregister":"Unregister","close":"ปิด","O365Rooms":"ห้อง {name}","syncUser":"อัพเดทข้อมูลผู้ใช้งาน"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/button/TH.json
// module id = 913
// module chunks = 150